module.exports = __webpack_public_path__ + "static/media/Rides.d9a7cdf5.svg";